import { render, staticRenderFns } from "./ProjectsAccordions.vue?vue&type=template&id=0fb97971&scoped=true&lang=pug&"
import script from "./ProjectsAccordions.vue?vue&type=script&lang=js&"
export * from "./ProjectsAccordions.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsAccordions.vue?vue&type=style&index=0&id=0fb97971&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb97971",
  null
  
)

export default component.exports